import zhTw from './zh-tw';
import zhCn from './zh-cn';
import en from './en';

export default {
  'zh-tw': zhTw,
  'zh-cn': zhCn,
  en,
};
